module.exports = __webpack_public_path__ + "img/paperSize.912aea30.png";